import React from 'react';
import { ButtonComp } from 'atoms/Buttons';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { LOCAL_STORAGE_KEYS } from 'common/constants/SharedConstants';
import { AUTO_DETECT_CONSTANTS, MODAL_MSG_CONSTANTS } from '../Constants/AutoDetectionConstants';

const WelcomeBackComponent = props => {
  const { onCancel, updateHandler } = props;
  const { LOCALIZATION_CHANGE_TITLE1, LOCALIZATION_CHANGE_TITLE2, LOCALIZATION_CHANGE_CONTENT, PREVIOUS_ADDRESS } =
    MODAL_MSG_CONSTANTS;
  const { PREVIOUS_ADDRESS_BUTTON, UPDATE_LOCATION_BUTTON } = AUTO_DETECT_CONSTANTS;

  const addressFromPrevious = localStorage.getItem(LOCAL_STORAGE_KEYS.RETAIN_ADDRESS);

  return (
    <div className='welcome-container'>
      <div className='welcome-back-heading'>
        <p className='mb-0'>{translateWithI18Next(LOCALIZATION_CHANGE_TITLE1)}</p>
        <p>{translateWithI18Next(LOCALIZATION_CHANGE_TITLE2)}</p>
      </div>
      <div className='order-details-section'>
        <p className='mb-0 order-type'>{translateWithI18Next(PREVIOUS_ADDRESS)}</p>
        <p>{addressFromPrevious}</p>
      </div>
      <p className='update-text'>{translateWithI18Next(LOCALIZATION_CHANGE_CONTENT)}</p>
      <div className='buttonItems'>
        <ButtonComp
          data-testid='welcome-back-change-button'
          className='button whiteButton blackBorder closebtn-cls'
          onClickHandler={onCancel}
        >
          {PREVIOUS_ADDRESS_BUTTON}
        </ButtonComp>
        <ButtonComp
          data-testid='yes-keep-it-btn'
          className='button blackButton blackBorder save-button'
          onClickHandler={updateHandler}
        >
          {UPDATE_LOCATION_BUTTON}
        </ButtonComp>
      </div>
    </div>
  );
};

export default WelcomeBackComponent;
